import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Form, Grid, Button } from 'semantic-ui-react';
import { Form as FinalForm } from 'react-final-form';

import { AppState } from 'services/types';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';
import ChecklistSchemasDropdown from 'components/ChecklistSchemasDropdown';
import { validators } from 'forms';

interface ConnectedProps {
    open?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export const CHECKLIST_TYPE_MODAL = 'checklistTypeModal';

export class ChecklistTypeModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [CHECKLIST_TYPE_MODAL]: undefined
        });
    };

    handleSubmit = (values: Record<string, any>): void => {
        const { schemaId } = values;

        this.props.updateQueryString({
            [CHECKLIST_TYPE_MODAL]: undefined,
            selectedSchema: schemaId,
            generalEventModal: true
        });
    };

    render(): React.ReactElement {
        const { open } = this.props;

        return (
            <Modal
                size="tiny"
                open={open}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <Modal.Header>
                    Select Checklist Type
                </Modal.Header>
                <Modal.Content>
                    <FinalForm
                        onSubmit={this.handleSubmit}
                        render={({ handleSubmit }): React.ReactElement => (
                            <Form onSubmit={handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <ChecklistSchemasDropdown
                                                validate={validators.isRequired}
                                                name="schemaId"
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                <Grid>
                                    <Grid.Column mobile={16} tablet={8} computer={8}>
                                        <Button
                                            type="button"
                                            onClick={this.handleClose}
                                            fluid
                                            basic
                                            primary
                                        >
                                            Cancel
                                             </Button>
                                    </Grid.Column>
                                    <Grid.Column mobile={16} tablet={8} computer={8}>
                                        <Button type="submit" primary fluid>
                                            Create job
                                            </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        )}
                    />
                </Modal.Content>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue(CHECKLIST_TYPE_MODAL)
});

export default connect(
    mapStateToProps,
    {
        updateQueryString
    }
)(ChecklistTypeModalComponent);
